import { BigNum, PRICE_PRECISION_EXP } from '@velocity-exchange/sdk';
import { USDT_SPOT_MARKET_INDEX } from '@velocity-exchange/common';

/**
 * Get the price to use for deposit validation.
 * For USDC and USDT, always returns exactly $1 to avoid validation failures
 * due to oracle price fluctuations (e.g., USDC oracle at $0.9998 causing 10 USDC to fail $10 minimum).
 * For other assets, returns the oracle price.
 */
export function getDepositValidationPrice(
	marketIndex: number,
	oraclePrice: BigNum
): BigNum {
	if (marketIndex === USDT_SPOT_MARKET_INDEX) {
		return BigNum.fromPrint('1', PRICE_PRECISION_EXP);
	}

	return oraclePrice;
}
